<div class="steps-modal">
  <div class="steps-modal__header" [class.scrolled]="isScrolled">
    <h2 class="steps-modal__title">{{ titulo }}</h2>
    <button
      type="button"
      class="steps-modal__close"
      (click)="cerrar()"
      aria-label="Cerrar"
    >
      <ion-icon name="close-outline"></ion-icon>
    </button>
  </div>

  <div class="steps-modal__body" #scrollContainer (scroll)="onScroll($event)">
    <p class="steps-modal__intro">
      {{ descripcion }}
    </p>

    <ol class="steps-modal__list">
      <li class="steps-modal__item" *ngFor="let paso of pasos">
        <div class="steps-modal__item-badge">
          <span>{{ paso.numero }}</span>
        </div>
        <div class="steps-modal__item-content">
          <p class="steps-modal__item-title">
            {{ paso.titulo }}
          </p>
          <p class="steps-modal__item-text">
            {{ paso.descripcion }}
          </p>
        </div>
      </li>
    </ol>
  </div>

  <div class="steps-modal__footer" [class.scrolled]="isScrolled">
    <button
      type="button"
      class="steps-modal__primary-button"
      (click)="onPrimaryClick()"
    >
      {{ textoBotonPrimario }}
    </button>
  </div>
</div>

